import { createRoute } from "@tanstack/solid-router";
import { msg } from "@lingui/core/macro";
import { Bot } from "@fleet/icons";
import { AI_CHATBOT_KEY } from "@space/shared";
import { adminRoute } from "./admin";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
// FLAGS: the entire page is gated by the chatbot capability.
import { FeatureGate } from "@/features/flags/feature-gate";
import { AcademyBotPanel } from "@/features/academy-bot/deflection-panel";

function AdminAcademyBotPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="4xl">
      <FeatureGate feature={AI_CHATBOT_KEY}>
        <PageHeader
          title={t(msg`Academy assistant`)}
          description={t(
            msg`What the assistant tells people who are not students yet, and how often it saves your team a conversation.`,
          )}
          icon={Bot}
        />
        <div class="mt-6">
          <AcademyBotPanel />
        </div>
      </FeatureGate>
    </PageContainer>
  );
}

export const adminAcademyBotRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/academy-bot",
  component: AdminAcademyBotPage,
});
